  @if (priceSheets?.length && assetType) {
  <div>
    <nb-list>
      @for (priceSheet of priceSheets; track priceSheet) {
        <nb-list-item class="row m-0 py-4">
          @if (currentAssetId || inWizard) {
            <div class="col-1 pricesheet-column">
              <input
                class="form-check-input"
                name="isSelected"
                type="radio"
                [value]="priceSheet.id"
                [disabled]="!canEdit"
                (change)="updateSelectedPriceSheet(priceSheet, priceSheet.is_default)"
                [checked]="priceSheet.id === selectedPriceSheetId"
                >
              </div>
            }
            <div class="col-4 pricesheet-column">
              <span>{{ priceSheet.label }}</span>
              <span>{{ 'Average price' | translate }} : {{ priceSheet.average_price | thousandsSeparator }} {{ currency}}
                / {{ priceSheet.quantity_unit?.name || ("unit" | translate) }}
                @if (assetQuantity > 1 && !asset) {
                  <span>
                    {{ "for" | translate }} {{ assetQuantity || 1 }} {{ quantityUnits[assetType.quantity_unit] || ("unit" | translate) }}
                  </span>
                }
                @if (asset && asset.quantity > 1 && !assetQuantity) {
                  <span>
                    {{ "for" | translate }} {{ asset.quantity || 1 }} {{ quantityUnits[assetType.quantity_unit] || ("unit" | translate) }}
                    ({{ "For a total of" | translate }} {{ (priceSheet.average_price * (asset.quantity || 1)) | ngxCurrency:currency:1 }})
                  </span>
                }
              </span>
              <span>
                {{ "Source" | translate }} :
                {{ priceSheet.author | ngxUsername }}
              </span>
            </div>
            <div class="col-3 pricesheet-column default">
              <div class="row">
                <div class="col-3 default-input">
                  @if (showIsDefault && canEdit) {
                    <input
                      class="form-check-input"
                      name="isDefault"
                      type="radio"
                      [value]="priceSheet.id"
                      [checked]="priceSheet.is_default"
                      (change)="changeDefaultPricesheet(priceSheet.id)"
                    >
                  }
                </div>

                <div class="col-9 default-label-col">
                  @if (priceSheet.is_default && showIsDefault) {
                    <div class="default-label">
                      {{"Default price sheet" | translate}}
                    </div>
                  }
                </div>

              </div>
            </div>
            <div class="col-2 pricesheet-column more-details">
              <a (click)="openDetails(priceSheet, assetType)">{{ "More details" | translate }}</a>
            </div>
            @if (canEdit && !priceSheet.is_benchmark) {
              <div class="col-1 pricesheet-column modify">
                <span
                  class="modify-icon"
                  (click)="updatePriceSheet(priceSheet)"
                >
                  <i class="fa-light fa-pen-to-square"></i>
                </span>
              </div>
              <div class="col-1 pricesheet-column delete">
                <span
                  class="delete-icon"
                  [class]="priceSheet.is_in_use ? 'undeletable' : 'deletable'"
                  (click)="deletePricesheet(priceSheet)"
                >
                  <i class="fa-light fa-trash-can"></i>
                </span>
              </div>
            }
          </nb-list-item>
        }
      </nb-list>
    </div>
  }

  @if (!priceSheets || !priceSheets?.length) {
    <div class='no-payback'>
      <fa-icon icon="file"></fa-icon>
      <span>{{ "No price sheet" | translate }} @if (asset && assetType) {
        {{ "for asset type" | translate }} <b>{{ assetType.name }}</b>
      }</span>
    </div>
  }
